export default __webpack_public_path__ + "static/baloon-464418cfa7ce839ab6473273e460baf7.png";